import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	selector: "app-school-messenger-attendance",
	templateUrl: "./school-messenger-attendance.component.html",
	styleUrls: ["./school-messenger-attendance.component.css"],
})
export class SchoolMessengerAttendanceComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private reportService: ReportService, private dialogService: DialogService) {}

	report = {
		SchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		AttendanceStatusID: 0,
		EntryTypeID: 0,
		OrderByID: "EntryTime", //Entry Time
		SortOrderID: "ASC", //ASC
	};

	lstAttendanceStatus: any = [];
	lstEntryType: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstOrderBy = [
		{
			OrderByID: "EntryTime",
			OrderByDesc: "Entry Time",
		},
		{
			OrderByID: "FirstName",
			OrderByDesc: "First Name",
		},
		{
			OrderByID: "LastName",
			OrderByDesc: "Last Name",
		},
		{
			OrderByID: "AttendanceStatus",
			OrderByDesc: "Attendance Status",
		},
		{
			OrderByID: "EntryType",
			OrderByDesc: "Entry Type",
		},
	];

	lstSortOrder = [
		{
			SortOrderID: "ASC",
			SortOrderDesc: "Ascending",
		},
		{
			SortOrderID: "DESC",
			SortOrderDesc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 435;

	subscription: any;

	ngOnInit() {
		this.AttendanceStatusList();
		this.EntryTypeList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		// this.AttendanceStatusList();
		// this.ExcuseList();
	}

	private AttendanceStatusList() {
		this.report.AttendanceStatusID = 0;
		var result = this.reportService.AttendanceStatusGetList();
		result.subscribe(
			(response) => {
				this.lstAttendanceStatus = response;

				if (this.lstAttendanceStatus.length == 0) {
					this.lstAttendanceStatus.unshift({
						AttendanceStatusID: 0,
						AttendanceStatusDesc: "All Attendance Status",
					});
				}

				this.report.AttendanceStatusID = this.lstAttendanceStatus[0].AttendanceStatusID;
			},
			(error) => {}
		);
	}

	private EntryTypeList() {
		this.report.EntryTypeID = 0;
		var result = this.reportService.EntryTypeGetList();
		result.subscribe(
			(response) => {
				this.lstEntryType = response;

				if (this.lstEntryType.length == 0) {
					this.lstEntryType.unshift({
						EntryTypeID: 0,
						EntryTypeDesc: "All Enty Types",
					});
				}

				this.lstEntryType = Array.from(this.lstEntryType).sort((a: any, b: any) => a.EntryTypeID - b.EntryTypeID);

				this.report.EntryTypeID = this.lstEntryType[0].EntryTypeID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 435;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		var startDate = moment(this.report.StartDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.EndDate).format("MM/DD/YYYY");

		strParam += startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";
		strParam += "," + this.report.AttendanceStatusID + "|AttendanceStatusID";
		strParam += "," + this.report.EntryTypeID + "|EntryTypeID";
		strParam += "," + this.report.OrderByID + "|OrderBy";
		strParam += "," + this.report.SortOrderID + "|SortOrder";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
